<template>
  <el-container>
    <el-header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>资源中心</el-breadcrumb-item>
        <el-breadcrumb-item>充电桩型号管理</el-breadcrumb-item>
      </el-breadcrumb>
    </el-header>
    <el-main>
      <el-row>
        <el-col :span="24">
          <el-tabs v-model="activeName" type="border-card">
            <el-tab-pane label="充电桩型号列表" name="typeList">
              <el-row v-show="showFilters">
                <!--查询组件-->
                <search
                :typeSearchForm="typeSearchForm"
                :getTypesLoading="getTypesLoading"
                @submitTypeSearchForm="submitTypeSearchForm"
                ref="searchForm"
                ></search>
                <el-form>
                  <el-col :span="2.5" class="diy-class">
                    <el-form-item>
                      <el-button size="mini" type="primary" @click="typeAdd" icon="el-icon-plus" class="el-btn"
                                 v-if="checkPermission(['bee:res:pileType:saveOrUpdatePileType'])">
                        新增型号
                      </el-button>
                    </el-form-item>
                  </el-col>
                </el-form>
              </el-row>
              <!--       列表组件       -->
              <list
              :tableData="tableData"
              :typesLoading="typesLoading"
              @showViewVisible="showViewVisible"
              @typeEdit="typeEdit"
              @typeDelete="typeDelete"
              ></list>
              <!-- 分页组件 -->
              <Pagination v-bind:child-msg="pageparam" @callFather="changePage"></Pagination>
            </el-tab-pane>
          </el-tabs>
        </el-col>
      </el-row>
      <!--新增组件-->
      <add
        :editForm="editForm"
        :editFormVisible="editFormVisible"
        :powerDistributionModeData="enumData.powerDistributionModeData"
        :advertisingMachineData="enumData.advertisingMachineData"
        :editSubmitLoading="editSubmitLoading"
        @closeEditForm="closeEditForm"
        @editSubmit="editSubmit"
      ></add>
      <!--   视图组件   -->
      <detail
      :viewVisible="viewVisible"
      :detailForm="detailForm"
      @closeDetailForm="closeDetailForm"
      ></detail>
    </el-main>
  </el-container>
</template>

<script>
  import Pagination from '../../../components/Pagination'
  import typeApi from '../../resourceCenter/api/typeApi'
  import commonApi from '../../resourceCenter/api/commonApi'
  import {isInteger,isDecimalThanZero} from '../../../common/validator'
  import search from "./typeManager/search"
  import list from "./typeManager/list"
  import add from "./typeManager/add"
  import detail from "./typeManager/detail"

  export default {
    name: 'typeManager',
    data() {
      return {
        enumData: [{
          advertisingMachineData: '',
          powerDistributionModeData:''
        }],
        activeName: 'typeList',
        showFilters: true,
        typeSearchForm: {},
        tableData: [{}],
        formLabelWidth: '190px',
        getTypesLoading: false,
        typesLoading: false,
        editFormVisible: false,
        viewVisible: false, // 视图
        viewName: 'detailForm',
        editFormRules: {
          typeModel: [{required: true, message: '桩类型型号', trigger: 'blur'}],
          typeName: [{required: true, message: '桩类型名称', trigger: 'blur'}],
          ratedPower: [{required: true, message: '额定功率', trigger: 'blur'},{validator:isDecimalThanZero,trigger: 'blur'}],
          outputVoltageRange: [{required: true, message: '输出电压范围', trigger: 'blur'}],
          outputCurrentRange: [{required: true, message: '输出电流范围', trigger: 'blur'}],
          // chargingCurrentRangePerGun: [{required: true, message: '每把枪均充电流范围', trigger: 'blur'}],
          // powerDistributionMode: [{required: true, message: '功率分配方式', trigger: 'blur'}],
          // lineLength: [{required: true, message: '枪线长度', trigger: 'blur'},{validator:isDecimalThanZero,trigger: 'blur'}],
          gunCount: [{required: true, message: '充电枪数量', trigger: 'blur'},{validator:isInteger,trigger: 'blur'}],
          // advertisingMachine: [{required: true, message: '是否带广告机', trigger: 'blur'}],
          // moduleBrandModel: [{required: true, message: '模块品牌型号', trigger: 'blur'}],
          // modularPower: [{required: true, message: '模块功率', trigger: 'blur'},{validator:isDecimalThanZero,trigger: 'blur'}],
          // modularCount: [{required: true, message: '模块数量', trigger: 'blur'},{validator:isInteger,trigger: 'blur'}],
          // completeMachineWeight: [{required: true, message: '整机重量', trigger: 'blur'},{validator:isDecimalThanZero,trigger: 'blur'}],
          // versionNumber:[{required: true, message: '软件版本号', trigger: 'blur'}],
          // currentRange: [{required: true, message: '电流', trigger: 'blur'}],
          // voltageRange: [{required: true, message: '电压', trigger: 'blur'}],
          // powerRange: [{required: true, message: '功率', trigger: 'blur'}]

        },
        editSubmitLoading: false,
        editForm: {},
        detailForm: {},
        pageparam: {
          t: {},
          currentPage: 1,
          pageSize: 10,
          total: 0
        },
        activeNames: ['basicInformation']
      }
    },
    methods: {
      resetTypeSearchForm() {
        this.typeSearchForm = {}
      },
      submitTypeSearchForm() {
        this.$refs.searchForm.$children[0].validate((valid) => {
          if (!valid) {
            return;
          }
          this.getTypesLoading = true
          this.typesLoading = true
          // let param = Object.assign({}, this.stationSearchForm)
          // para.date = (!para.date || para.date == '') ? '' : util.formatDate.format(new Date(para.date), 'yyyy-MM-dd');
          this.pageparam.t = this.typeSearchForm
          let param = Object.assign({}, this.pageparam)
          typeApi.getPileTypes(param).then((res) => {
            if (res.code === 0) {
              this.pageparam.total = res.data.total
              this.tableData = res.data.records
              // this.$message({
              //   message: res.message,
              //   type: 'success'
              // })
            } else {
              // this.$message.error(res.message)
            }
            this.getTypesLoading = false
            this.typesLoading = false
          })
        })
      },
      // 编辑
      typeAdd() {
        this.$nextTick(() => {
          this.editFormVisible = true
          this.editForm = Object.assign({})
        })
      },
      closeEditForm(){
        this.editFormVisible=false
      },
      typeDetail(index, row) {
        this.detailForm = Object.assign({}, row)
      },
      closeDetailForm(){
        this.viewVisible=false
      },
      editSubmit(editForm) {
        editForm.validate((valid) => {
            if (!valid) {
              return;
            } else {
              this.$confirm('确认提交吗？', '提示', {}).then(() => {
                this.editSubmitLoading = true
                let param = JSON.stringify(this.editForm)
                typeApi.saveOrUpdatePileType(param).then((res) => {
                  this.editSubmitLoading = false
                  if (res.code === 0) {
                    this.$message({
                      message: res.message,
                      type: 'success'
                    })
                    this.editFormVisible = false
                    this.submitTypeSearchForm()
                  } else {
                    this.$message.error(res.message)
                  }
                })
              })
            }
        })
      },
      clearEditForm(){
        this.$refs.editForm.clearValidate()
      },
      showViewVisible(index, row) {
        this.typeDetail(index, row)
        this.viewVisible = true
      },
      typeEdit(index, row) {
        this.editFormVisible = true
        this.editForm = Object.assign({}, row)
        this.editForm.advertisingMachine = row.advertisingMachineCode
        this.editForm.powerDistributionMode = row.powerDistributionModeCode
      },
      // 删除
      typeDelete(index, row) {
        this.$confirm('确定要删除：' + row.typeName + '吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            typeApi.deletePileType(row.id).then((res) => {
              if (res.code === 0) {
                this.$message({
                  message: res.message,
                  type: 'success'
                })
                this.submitTypeSearchForm()
              } else {
                this.$message.error(res.message)
              }
            })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除！'
            })
          })
      },
      changePage() {
        this.submitTypeSearchForm()
      },
      // 加载下拉框
      loadSelectItem() {
        typeApi.getPileTypeEnum().then((res) => {
          this.enumData.advertisingMachineData = JSON.parse(res.advertisingMachineData)
          this.enumData.powerDistributionModeData = JSON.parse(res.powerDistributionModeData)
        })
      }
    },
    components: {
      Pagination,
      search,
      list,
      add,
      detail
    },
    created: function () {
      this.loadSelectItem()
    },
    mounted: function () {
      this.submitTypeSearchForm()
    }
  }
</script>

<style scoped lang="less">
  .el_search {
    background-color: teal;
    color: white;
  }

  .el_clear {
    background-color: darkorange;
    color: white;
  }

  .el-btn {
    /*float: right;*/
    margin-bottom: 15px;
  }

  /deep/ .search_form {
    .el-form-item__content {
      .el-input {
        width: auto;
      }
    }
  }
  /deep/.el-dialog{
    width: 900px;
  }
  /deep/ .edit_form, /deep/ .detail_form {
    height: 600px;
    overflow: auto;

    .el-form-item__label {
      color: rgba(0, 0, 0, 0.47);
    }
  }
  /deep/ .diy-class {
    .el-form-item__content {
      line-height: 0px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/typeManager.vue